/**
 * Maps US state / territory display names (as used in AddressForm) to Firestore regionalLookup doc IDs.
 * Matches Docket's regionalLookup/{stateAbbreviation} convention.
 */
const US_STATE_NAME_TO_ABBR = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  'District Of Columbia': 'DC',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Puerto Rico': 'PR',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
};

/**
 * @param {string | undefined} stateFullName — e.g. "California", "District Of Columbia"
 * @returns {string | undefined} two-letter abbreviation or undefined if unknown / empty
 */
export function getUsStateAbbreviation(stateFullName) {
  if (!stateFullName || typeof stateFullName !== 'string') {
    return undefined;
  }
  const trimmed = stateFullName.trim();
  if (trimmed.length === 2) {
    return trimmed.toUpperCase();
  }
  return US_STATE_NAME_TO_ABBR[trimmed];
}
